import { Link } from "react-router-dom";
import Voetnoot from "../../components/Voetnoot";
import Viewer from "../../components/Viewer";
import ImageDownload from "../../components/ImageDownload";

const data = {
  title: "Samenvatting",
  content: (
    <>
      <p>
        Dit MER heeft betrekking op de ontwerp Herziening van de module
        Energietransitie van het Omgevingsbeleid van de provincie Zuid-Holland.
        De vaststelling van de zeven RES'en binnen de provincie Zuid-Holland
        vormt de belangrijkste aanleiding om de module Energietransitie te
        herzien. In de RES-regio’s is gezocht naar mogelijkheden voor opwekking
        van duurzame energie (zonne-energie en windenergie) om daarmee
        uitvoering te geven aan het Klimaatakkoord. De herziening dient om de
        vanuit de RES'en voortkomende duurzame opwek van elektriciteit op land
        mogelijk te maken.
      </p>

      <h3>Doel en scope van het MER </h3>

      <p>
        Dit MER richt zich op de onderdelen zon en wind van de herziening en
        daarbij specifiek op de aanpak voor de verdere uitwerking van de
        zoekgebieden voor zon en wind in het Omgevingsprogramma.
        <Voetnoot id="1">1</Voetnoot> In de ontwerp Herziening is dit beschreven
        als maatregel: RES-zoekgebieden zon en wind onder beleidskeuze 3-1-3
        Bevorderen energietransitie. In de zeven RES’en in Zuid-Holland zijn de
        doelen per regio voor grootschalige zonne- en windenergie uitgewerkt. De
        RES’en zijn als strategische verkenning vastgesteld door Provinciale
        Staten (hierna: PS). Om een indicatie te geven van het potentieel
        doelbereik in dit MER is daarom gekozen om de opwekdoelstellingen van de
        RES'en te vertalen naar een indicatieve opgave die in de zoekgebieden te
        realiseren is, uitgedrukt in aantal windturbines en hectares zonneveld.
      </p>
      <p>
        Onderstaande tabel geeft een overzicht van doelstelling per regio
        vertaald naar aantallen en hectares. Een nadere toelichting op de
        totstandkoming van de aantallen in de tabel is opgenomen in <Link to="/energietransitie/5/2">paragraaf 5.2</Link>.
      </p>

      <table className="paragraaf-5-2" id="paragraaf-5-2">
        <thead>
          <tr>
            <th>Energieregio </th>
            <th>Totaal bod TWh/jr </th>
            <th>Nieuw te realiseren TWh/jr </th>
            <th>Nieuw grootschalig zon en wind TWh/jr </th>
            <th>Windturbines (aantal) </th>
            <th>Zonneveld (hectares) </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Alblasserwaard </td>
            <td>0,32 </td>
            <td>0,24 </td>
            <td>0,121 </td>
            <td>7 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Drechtsteden </td>
            <td>0,37 </td>
            <td>0,248 </td>
            <td>0,13 </td>
            <td>1 </td>
            <td>180 </td>
          </tr>
          <tr>
            <td>Goeree Overflakkee </td>
            <td>0,85 </td>
            <td>0,052 </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Hoeksche Waard </td>
            <td>0,39-0,48 </td>
            <td>0,003-0,093 </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Holland Rijnland </td>
            <td>1,14 </td>
            <td>0,94 </td>
            <td>0,499 </td>
            <td>5 </td>
            <td>480 </td>
          </tr>
          <tr>
            <td>Midden-Holland </td>
            <td>0,44 </td>
            <td>0,338 </td>
            <td>0,103 </td>
            <td>0 </td>
            <td>155 </td>
          </tr>
          <tr>
            <td>Rotterdam – Den Haag </td>
            <td>2,8-3,2 </td>
            <td>1,444 </td>
            <td>0,752 </td>
            <td>19 </td>
            <td>645 </td>
          </tr>
          <tr className="bold">
            <td>Provincie Zuid-Holland totaal </td>
            <td>6,4-6,8 </td>
            <td>2,848-3,278 </td>
            <td>1,6 </td>
            <td>32 (ca 0,6 TWh/jr) </td>
            <td>1460 (ca 1 TWh/jr) </td>
          </tr>{" "}
        </tbody>
      </table>

      <p>
        Het doel van dit MER is om de milieueffecten van de inpassing van
        toekomstige ontwikkeling van windenergie en zonne-energie binnen de
        zoekgebieden inzichtelijk te maken, zodat deze bij het vaststellen van
        het ontwerpbeleid gewogen kunnen worden. Op grond van de milieueffecten
        is de mate van kansrijkheid van de inpassing van windenergie en
        zonne-energie beoordeeld. Ook is onderzocht of de doelstelling binnen de
        zoekgebieden haalbaar is. Daarnaast biedt de analyse inzicht voor het
        concretiseren van de zoekgebieden in de RES 2.0.
      </p>

      <h3>Aanpak</h3>
      <p>Onderstaande figuur geeft de hoofdlijnen van de aanpak van de beoordeling van de zoekgebieden weer. De als strategische verkenning vastgestelde RES’en vormen het startpunt. Onder het figuur zijn de bouwstenen van dit MER nader toegelicht.</p>

      <img src={require('./images/Paragraaf 1.4 - Screenshot - Werkwijze MER.png')} alt='Werkwijze van het MER' />
      
      <h4>Zoekgebieden zon en wind</h4>
      <p>De door de RES-regio’s zelf opgestelde kaartbeelden met de zoekgebieden voor grootschalige opwek van zon- en windenergie, vormen de basis voor de kaartbeelden in dit MER. <Voetnoot id="2">2</Voetnoot> De samengestelde kaarten met de zoekgebieden in dit MER vormen een verzameling van de zoekgebieden van de RES’en in Zuid-Holland. De data om de zoekgebieden in te tekenen zijn aangeleverd door de verschillende RES’en. De zoekgebieden zijn aangepast naar een eenduidige legenda voor dit MER. De kleur of duiding van de zoekgebieden kan verschillen met de originele kaart uit de betreffende RES. De locatie en ligging van de zoekgebieden zijn exact overgenomen.</p>

      <h4>Beoordelingscriteria zoekgebieden zon en wind</h4>
      <p>De realisatie van windturbines en zonnevelden in de zoekgebieden heeft effecten op verschillende milieu- en leefomgevingsaspecten. Onderstaande tabel bevat een overzicht van de onderzochte criteria. Een specifieke toelichting van de beoordeling en werkwijze per criterium is opgenomen in hoofdstuk 4. Bij de beoordelingscriteria is de referentiesituatie (inclusief kaartbeeld) van het betreffende criterium in de provincie Zuid-Holland in beeld gebracht. Bij de criteria wordt steeds onderscheid gemaakt in de beoordeling van de zoekgebieden voor zon en de beoordeling van de zoekgebieden voor wind.</p>

      <table className="w100" id="paragraaf-1-4-1">
            <tr className="kopje">
                <td>Beoordelingscriterium</td>
                <td>Onderdelen</td>
            </tr>
            <tr>
                <td>1. N2000/ stikstofoverschrijding</td>
                <td><ul><li>(Stikstofgevoelige) N2000 gebieden (en buffer rondom de gebieden)</li></ul></td>
            </tr>
            <tr>
                <td>2. Natuurnetwerk Nederland</td>
                <td><ul><li>NNN gebieden</li></ul></td>
            </tr>
            <tr>
                <td>3. Overige beschermde gebieden</td>
                <td>
                    <ul>
                        <li>Weidevogelgebieden</li>
                        <li>Ganzenrustgebieden</li>
                        <li>Stiltegebieden</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td>4. Soorten</td>
                <td>
                    <ul>
                        <li>Vogels</li>
                        <li>Vogeltrek</li>
                        <li>Vleermuizen</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td>5. Geluid</td>
                <td>
                    <ul>
                        <li>Geluidshinder op omliggende woningen: vuistregelafstanden (woningen/ woonkernen)</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td>6. Externe veiligheid </td>
                <td>
                    <ul>
                        <li>Risicozonering voor windturbines: 
                            <ul>
                                <li>Kwetsbare/ beperkt kwetsbare objecten</li>
                                <li>Buisleidingen</li>
                                <li>Gevaarlijke stoffen</li>
                                <li>Inrichtingen</li>
                                <li>Wegen/ waterwegen/ spoorwegen</li>
                                <li>Elektriciteitsinfra</li>
                                <li>Luchthaven</li>
                            </ul>

                        </li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td>7. Inpassing energie-infrastructuur</td>
                <td>
                    <ul>
                        <li>Afstand zoekgebieden tot stations (MS en TS)</li>
                        <li>Aansluitmogelijkheden (knelpunten) per station</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td>8. Drinkwatergebieden</td>
                <td>
                    <ul>
                        <li>Waterwingebied </li>
                        <li>Grondwaterbeschermingsgebied</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td>9. Woning-voorraadontwikkeling</td>
                <td>
                    <ul>
                        <li>Ruimtevraag en locatie nieuwbouwlocaties</li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td>10. Ruimte</td>
                <td>
                    <ul>
                        <li>De aspecten landschap, cultuurhistorie en ruimtelijke kwaliteit zijn voor deze beoordeling samengebracht tot één criterium ‘ruimte’ </li>
                    </ul>
                </td>
            </tr>
            <tr>
                <td>11. Duurzame energieopwekking en uitstoot broeikasgassen</td>
                <td>
                    <ul>
                        <li>Per alternatief: te verwachten energieopbrengst (TWh): bandbreedte</li>
                        <li>Per alternatief: vermeden CO2-uitstoot op basis van te verwachten energieopbrengst (TWh)</li>
                    </ul>
                </td>
            </tr>
        </table>


    <h4>Analyse en beoordeling zoekgebieden</h4>
    <p>De aard van de effecten op het milieu en de leefomgeving zijn sterk afhankelijk van de precieze locatie en kunnen derhalve verschillen binnen de zoekgebieden. De beoordeling van milieueffecten is in dit MER daarom weergegeven in kaarten. Op grond van de locaties van de zoekgebieden en de geografische gegevens van de beoordelingscriteria zijn met een geografisch informatiesysteem (hierna: GIS) analyses gemaakt van de overlappen tussen de criteria en (delen van) de zoekgebieden. De milieueffecten in deze ‘overlapgebieden’ zijn vervolgens door experts binnen de provincie Zuid-Holland beoordeeld. Deze beoordelingen en onderliggende analyses zijn vervolgens gedeeld met externe meelezers (Omgevingsdiensten) voor een second opinion. Op basis van onderstaande driepuntsschaal is de kansrijkheid van realisatie van windturbines en zonnevelden in de zoekgebieden beoordeeld. Voor de specifieke maatlat per beoordelingscriterium wordt verwezen naar hoofdstuk 4.  </p>

    <table className='beoordeling' id="paragraaf-1-4-2">
            <tr>
                <th>Beoordeling</th>
                <th>Algemene toelichting</th>
            </tr>
            <tr className='score-1'>
                <td>Redelijk kansrijk tot kansrijk</td>
                <td>Gebieden die als (redelijk) kansrijk zijn beoordeeld, zijn waarschijnlijk geschikt vanuit milieuperspectief.</td>
            </tr>
            <tr className='score-2'>
                <td>Matig kansrijk tot kansrijk te maken</td>
                <td>Deze delen van zoekgebieden hebben niet de voorkeur vanuit milieuperspectief. Wel zijn de effecten te beperken onder voorwaarden. Mogelijk zijn deze gebieden geschikt te maken.</td>
            </tr>
            <tr className='score-3'>
                <td>Niet tot nauwelijks kansrijk</td>
                <td>Deze delen van zoekgebieden zijn waarschijnlijk niet of nauwelijks haalbaar vanuit milieuperspectief. Bijvoorbeeld omdat het effect strijdig is met wet- en regelgeving.</td>
            </tr>
        </table>

        <h4>Opstellen en beoordelen alternatieven </h4>
        <p>In het kader van dit MER zijn vier alternatieven opgesteld voor de opwek van elektriciteit door middel van windenergie en grootschalige zonne-energie.</p>

        <ol>
            <li><i>Alternatief RES 1.0- basis.</i><br />De zoekgebieden en zoeklocaties voor zon en wind zoals ze de door de zeven Zuid-Hollandse energieregio’s zijn voorgesteld.</li>
            <li><i>Alternatief RES 1.0- na besluitvorming.</i><br /> De zoekgebieden en zoeklocaties zoals PS ze heeft vastgesteld als strategische verkenning (zoekgebieden voor wind in het Groene Hart zijn niet vastgesteld). Zoals in <Link to="/energietransitie/1/3">paragraaf 1.3</Link> aangegeven wordt in het ontwerpbeleid (Omgevingsprogramma) geen nadere keuze gemaakt in de begrenzing van de zoekgebieden. Dit alternatief komt dus overeen met de wijze waarop de zoekgebieden in het huidige ontwerpbeleid zijn vastgesteld.</li>
            <li><i>Alternatief landschap.</i><br /> Opwek van zon en wind in landschappen die daar het meest geschikt voor zijn. Voor de uitwerking van dit alternatief wordt gebruik gemaakt van de adviespunten van de Provinciaal Adviseur Ruimtelijke Kwaliteit (Meer dan zon en wind alleen, advies Regionale Energiestrategieën 1.0 Zuid-Holland).</li>
            <li><i>Alternatief haalbaar en betaalbaar.</i><br /> Onderzocht wordt hoe vanuit het perspectief van de netwerkcapaciteit de RES’en het beste uitgewerkt kunnen worden. </li>
        </ol>
        
        <p>De alternatieven laten zien hoe binnen de zoekgebieden op verschillende manieren invulling gegeven kan worden aan de doelstelling. Het opgetelde bod (in TWh) van de RES-regio’s vormt de doelstelling op provinciaal niveau. De doelstelling is vertaald in het aantal nieuw te ontwikkelen windturbines en hectares zonneveld. De alternatieven zijn vervolgens beoordeeld op dezelfde criteria waarmee in de eerste ronde de ruimte binnen de zoekgebieden is beoordeeld. Daarnaast is op een rij gezet in hoeverre ze invulling geven aan de doelstellingen voor energieproductie.</p> 

        <h3>Effectanalyse zoekgebieden zon en wind </h3>
        <p>In deze fase is er nog geen concreet en eenduidig beeld van de plannen of projecten in de zoekgebieden. Om dit te ondervangen zijn geen plannen of projecten beoordeeld, maar alleen de kans op een acceptabele inpassing van toekomstige ontwikkeling van windenergie en zonne-energie binnen de zoekgebieden aan de hand van de milieueffecten ten opzichte van de referentiesituatie. De milieueffecten zijn daarmee slechts een globale inschatting van de mogelijke ruimtelijke gevolgen.</p>
        <p>In hoofdstuk 4 is per beoordelingscriterium de referentiesituatie beschreven (en op kaart gezet), de beoordelingsmethodiek toegelicht en de beoordeling ten opzichte van de referentiesituatie beschreven. De beoordelingen zijn per criterium in interactieve kaartbeelden te bekijken. Onderstaande interactieve kaart geeft een samenvattend beeld van de beoordeling van de toekomstige ontwikkeling van windenergie en zonne-energie binnen alle individuele zoekgebieden aan de hand van de beoordelingscriteria. Daarbij is per beoordelingscriterium aangegeven in hoeverre de kans op een acceptabele inpassing van toekomstige ontwikkeling van windenergie en zonne-energie binnen de zoekgebieden mogelijk is (kansrijkheid van inpassing op grond van mogelijke milieueffecten). In de kaart kan een selectie worden gemaakt tussen de beoordelingen voor windenergie en voor zonne-energie. Vervolgens kan een criterium worden geselecteerd (bijvoorbeeld externe veiligheid) om de beoordeling van het betreffende criterium in alle zoekgebieden te bekijken. Alle individuele zoekgebieden staan op de kaart. Het is daarmee ook mogelijk om voor een specifiek zoekgebied de beoordeling van alle criteria langs te lopen. Ter indicatie is per beoordelingscriterium (totaal en per zoekgebied) aangegeven welk percentage van het areaal kansrijk is voor acceptabele inpassing van toekomstige ontwikkeling van windenergie en zonne-energie, bezien vanuit het beoordelingscriterium. Dit zegt nog niets over de mate waarin de ruimte functioneel geschikt is. Bij het ontwerpen van de alternatieven is een inschatting gemaakt van de beschikbare ruimte voor de opwerk van zonne-energie en windenergie.  </p>

        <Viewer src="https://zuid-holland.maps.arcgis.com/apps/dashboards/16dc339831ec4058aefe91d9c950d01b" />

        <p>De beoordeling van de kansrijkheid van de inpassing van zonne-energie en windenergie aan de hand van de mogelijke milieu- en leefomgevingseffecten levert op hoofdlijnen de volgende inzichten op:</p>
        <ul>
            <li>Er is in (zeer) beperkte mate sprake van overlap tussen Natura 2000-gebieden (en buffers rond deze gebieden), Natuurnetwerk Nederland en de zoekgebieden uit de RES’en voor zon en wind. Op de specifieke locaties waar wel sprake van overlap is, wordt realisatie niet kansrijk geacht. Ook de overlap tussen de overige beschermde gebieden en de zoekgebieden voor zon en wind is beperkt. Wel zijn er verschillende plekken met overlappen tussen de zoekgebieden voor zon en weidevogelgebieden, met name in Midden-Holland en Holland-Rijnland. Tot slot is er ook sprake van een zeer beperkte overlap tussen waterwingebieden, grondwaterbeschermingsgebieden en de zoekgebieden voor zon en wind. Ook hier zijn dus (zeer) beperkte negatieve effecten te verwachten. </li>
            <li>Uit de analyse van de verwachtte risico’s van windturbines op vogelsoorten (trekvogel, broedvogel, wintergast) aan de hand van de verspreiding, aantallen en vliegbewegingen van deze vogelsoorten blijkt dat er veel overlap is tussen zoekgebieden voor wind en risicogebieden voor aanvaring. Dit geldt met name voor het zoekgebied bij Hoek van Holland, de meer oostelijke delen van het zoekgebied A15 en de zoekgebieden rondom de N11 en de A4. Vanuit de mogelijke effecten op vleermuizen zijn met name de zoekgebieden rondom de N223, het Brielse Meer en de A4 als niet kansrijk beoordeeld. Deze beoordelingen geven een indicatief beeld. Om daadwerkelijk te weten of de plaatsing van windturbines een negatief effect heeft op vogels en vleermuizen, is nader onderzoek per soort op specifieke locaties nodig. Pas dan kan worden vastgesteld of de verwachte kwetsbare vogelsoorten daadwerkelijk nadelige gevolgen zullen ervaren van beoogde windturbines. </li>
            <li>Vanuit de mogelijke leefomgevingseffecten op geluid en externe veiligheid zijn grote delen van de zoekgebieden voor wind beoordeeld als niet kansrijk. Vanuit externe veiligheid gaat het om grote delen van de Rijnmond regio, Holland Rijnland en de zoekgebieden rondom de Rijkswegen. Vanuit geluid bezien zijn grote delen van Rijnmond juist als kansrijk beoordeeld. Ook hier geldt dat in Holland-Rijnland en de zoekgebieden rondom Rijkswegen grotendeels als niet-kansrijk zijn beoordeeld. Een aantal woningbouwlocaties (en/of de buffercontour voor geluid) ligt binnen zoekgebieden voor wind. Ook zijn er verschillende overlappen tussen woningbouwlocaties en zoekgebieden voor zon. Bij nadere uitwerking van de zoekgebieden in de RES 2.0 dient hier rekening mee gehouden te worden. Dit vraagt een nader inzicht in de concrete plannen op deze locaties.   </li>
            <li>De inpassing van zonne-energie en windenergie binnen de zoekgebieden op het elektriciteitsnet is beoordeeld aan de hand van de te overbruggen afstand tot stations om de zonnevelden en windturbines aan te sluiten en de knelpunten op deze stations voor invoeding. Het areaal ‘luwe gebieden’ in de zoekgebieden voor wind is beperkt. Het gaat om twee zoekgebieden voor wind ten noorden van de A4 die buiten de gehanteerde vuistregelafstanden voor het aansluiten liggen. Voor de beoordeling van de zoekgebieden voor zon is het netwerk meer differentiërend dan voor windenergie. Er bevinden zich een aantal zoekgebieden op grote afstand van de aansluitpunten in het netwerk. Dit zijn locaties die om technische en financiële redenen niet zonder meer geschikt zijn en investeringen in het netwerk vragen. Het gaat vooral om zoekgebieden in Holland-Rijnland en Midden-Holland. Een aantal zoekgebieden liggen binnen het bereik van stations, maar hebben risico op opname door de netbeheerder in verband met knelpunten in de capaciteit. Hier dient in de verdere uitwerking – in afstemming met de netbeheerders – rekening mee gehouden te worden. </li>
            <li>De aspecten landschap, cultuurhistorie en ruimtelijke kwaliteit zijn voor deze beoordeling samengebracht tot één criterium ‘ruimte’. Uit de beoordeling van de inpassing van windenergie blijkt dat het grootste areaal aan kansrijke zoekgebieden zich in het midden van de provincie (voornamelijk langs de infralijnen in de stedenband Maasvlakte-Rotterdam-Drechtsteden-Merwedezone) en langs de grootschalige infrastructuur in het noorden (A4 en A12) bevindt. Van de kleinere zoekgebieden in het noorden is een groot deel als niet kansrijk beoordeeld op basis van dit criterium. In de beoordeling van zonne-energie zijn grote aaneengesloten niet kansrijke gebieden te zien tussen Woerden en de Reeuwijkse Plassen en tussen Bodegraven en Boskoop. Ook de omgeving van de N11 kleurt grotendeels donkerpaars, vooral aan de zuidzijde. Ook een aantal kleinere gebiedjes is donkerpaars gemarkeerd, waaronder zoekgebiedjes langs de Amstel, rond de Kagerplassen, in de Duin- en Bollenstreek en in de omgeving van de N44. Grote aaneengesloten kansrijke gebieden vinden we onder andere op Voorne-Putten, in de Zuidplaspolder en in het kassengebied tussen Bleiswijk en de A12.  </li>
        </ul>
        <p>Op grond van de mogelijke milieueffecten zijn verschillende (delen van) zoekgebieden vanuit verschillende criteria beoordeeld als niet kansrijk. Bij windenergie hebben met name effecten op geluid, soorten, externe veiligheid en ruimte een grote impact op de kansrijkheid van de zoekgebieden. Voor zon zijn met name effecten op het criterium ruimte bepalend voor de kansrijkheid.  </p>

        <h3>Alternatieven</h3>
        <p>De alternatieven laten zien hoe binnen de zoekgebieden op verschillende manieren invulling gegeven kan worden aan de doelstelling. Per alternatief wordt een specifiek accent gelegd waardoor dit op onderdelen gaat verschillen ten opzichte van alternatief RES 1.0- basis. De referentiesituatie voor de alternatieven is voor de verschillende onderzochte criteria (leefomgeving, natuur, water en landschap) beschreven in hoofdstuk 4. De bestaande windturbines en de projecten in ontwikkeling zijn beschouwd als onderdeel van de referentiesituatie. </p>
        
        <h4>Alternatief 1: RES 1.0- basis </h4>
        <p>Het basisalternatief is opgesteld om op provinciaal niveau inzicht te krijgen in de ruimtelijke impact van de richting die op regionaal niveau is ingezet. Vertrekpunt voor dit alternatief is daarom dat zoveel mogelijk wordt aangesloten bij de zeven energieregio’s. De doelstellingen voor windenergie en zonne-energie van de regio’s worden binnen de grenzen van deze regio’s geprojecteerd, waarbij de samenstelling van het bod (de verdeling tussen wind- en zonne-energie) in principe niet wijzigt. </p>
        <ImageDownload title="Kaartbeeld alternatief RES 1.0- basis (zonne- en windenergie)" defaultImage="energietransitie/images/20220505_Alternatief 1_zonwind.jpg" largeImage="energietransitie/images/20220505_Alternatief 1_zonwind.pdf" fileSize="1,4 MB" />
        
        <strong>Windenergie</strong>
        <p>Uitgangspunt is in eerste instantie plaatsing van het aantal windturbines dat voortkomt uit het RES bod per regio. Binnen dat uitgangspunt wordt zoveel mogelijk aangesloten bij de beoordeling van de zoekgebieden op de thema’s landschap, cultuurhistorie en ruimtelijke kwaliteit (waarin ook de plaatsingsvisie is meegenomen).  </p>
        <ImageDownload title="Kaartbeeld alternatief RES 1.0- basis (windenergie)" defaultImage="energietransitie/images/20220505_Alternatief 1_wind.jpg" largeImage="energietransitie/images/20220505_Alternatief 1_wind.pdf" fileSize="1 MB" />
        
        <strong>Zonne-energie</strong>
        <p>Het maximaal realistisch ingeschatte oppervlak aan zonneveld per cluster vormde de basis voor dit alternatief. Vervolgens zijn de benodigde oppervlaktes per regio verdeeld over deze clusters. Alle clusters van zoekgebieden zijn hierbij benut. Er heeft een zo evenredig mogelijke verdeling plaatsgevonden. In clusters met meer ruimte is een groter oppervlak geprojecteerd en in clusters met minder ruimte een kleiner oppervlak. </p>        
        <ImageDownload title="Kaartbeeld alternatief RES 1.0- basis (zon)" defaultImage="energietransitie/images/20220505_Alternatief 1_zon.jpg" largeImage="energietransitie/images/20220505_Alternatief 1_zon.pdf" fileSize="1,2 MB" />

        <h4>Alternatief 2: RES 1.0- na besluitvorming </h4>
        <p>Dit alternatief laat de doorwerking zien van de vaststelling van zoekgebieden en zoeklocaties door PS. De zoekgebieden voor wind in het Groene Hart zijn niet vastgesteld. Ten opzichte van het alternatief RES 1.0- basis vindt voor deze zoekgebieden een verschuiving plaats in de verdeling van aantallen windturbines en oppervlaktes zonneveld. Realisatie van de RES-ambitie binnen de betreffende regio is nog steeds het uitgangspunt, net als vasthouden aan de verdeling tussen wind- en zonne-energie. </p>

        <ImageDownload title="Kaartbeeld alternatief RES 1.0- na besluitvorming (zonne- en windenergie)" defaultImage="energietransitie/images/20220505_Alternatief 2_zonwind.jpg" largeImage="energietransitie/images/20220505_Alternatief 2_zonwind.pdf" fileSize="1,3 MB" />

        <strong>Windenergie</strong>
        <p>Alternatief RES 1.0- basis vormt het vertrekpunt. Als gevolg van het niet-vaststellen van de zoekgebieden in het Groene Hart wordt voor regio Den Haag de zoekruimte langs de A4 verkleind. Er blijft echter ruimte over om de aan dit cluster gekoppelde windturbines te kunnen plaatsen buiten het Groene Hart. In Holland Rijnland vervallen de windturbines die in alternatief RES 1.0- basis langs de A4 geprojecteerd waren. Deze turbines verschuiven naar de Duin- en Bollenstreek (omgeving A44 en N206). </p>
        <ImageDownload title="Kaartbeeld alternatief RES 1.0- na besluitvorming (windenergie)" defaultImage="energietransitie/images/20220505_Alternatief 2_wind.jpg" largeImage="energietransitie/images/20220505_Alternatief 2_wind.pdf" fileSize="1,1 MB" />

        <strong>Zonne-energie</strong>
        <p>De vaststelling van de zoekgebieden voor windenergie heeft geen consequenties voor de zoekgebieden voor zonne-energie. Voor zonne-energie wordt in dit alternatief dezelfde verdeling van oppervlaktes over de clusters aangehouden als bij alternatief RES 1.0- basis.</p>
        <ImageDownload title="Kaartbeeld alternatief RES 1.0- na besluitvorming (zonne-energie)" defaultImage="energietransitie/images/20220505_Alternatief 2_zon.jpg" largeImage="energietransitie/images/20220505_Alternatief 2_zon.pdf" fileSize="1,2 MB" />

        <p>Voor de inzichten met betrekking tot zonne-energie wordt verwezen naar alternatief RES 1.0- basis. Voor windenergie valt het volgende op:</p>
        <ul>
            <li>Het lijkt mogelijk om binnen de energieregio’s de eigen doelstelling voor windenergie te realiseren, met uitzondering van de Alblasserwaard. Net als in alternatief RES 1.0- basis is één turbine vanuit regio Alblasserwaard verschoven naar regio Rotterdam – Den Haag. </li>
            <li>Het uitsluiten van (delen van) zoekgebieden voor zover deze samenvallen met het Groene Hart heeft vooral consequenties voor regio Holland Rijnland. De windturbines die in alternatief RES 1.0- basis gekoppeld waren aan de A4 in Holland Rijnland verschuiven naar locaties in de Duin- en Bollenstreek.</li>
        </ul>

        <h4>Alternatief 3: landschap </h4>
        <p>Bij dit alternatief zijn doelstellingen voor opwekking van wind- en zonne-energie zoveel mogelijk geprojecteerd in die gebieden die daar vanuit de optiek van landschap, cultuurhistorie en ruimtelijke kwaliteit het meest geschikt voor zijn. Alle gebieden die vanuit de energieregio’s zijn aangedragen zijn hierbij in beschouwing genomen (inclusief de zoekgebieden voor windenergie binnen het Groene Hart). Op provinciaal niveau is de opgetelde energiedoelstelling gehandhaafd, net als de verdeling tussen wind- en zonne-energie. Voor zonne-energie zijn de regionale ambities binnen de zoekgebieden van de betreffende regio geprojecteerd. Om beter aan te kunnen sluiten bij de provinciale visie op het gebied van windenergie heeft hiervoor wel verschuiving tussen de regio’s plaatsgevonden. </p>
        <ImageDownload title="Kaartbeeld alternatief landschap (zonne- en windenergie)" defaultImage="energietransitie/images/20220505_Alternatief 3_zonwind.jpg" largeImage="energietransitie/images/20220505_Alternatief 3_zonwind.pdf" fileSize="1,4 MB" />

        <strong>Windenergie</strong>
        <p>Alternatief RES 1.0- basis vormt het vertrekpunt. Ten opzichte van dit basisalternatief is het alternatief landschap voor windenergie op de volgende punten geoptimaliseerd:</p>

        <ul>
            <li>Er zijn geen windturbines geprojecteerd in de Duin- en Bollenstreek. Deze turbines waren, in afwijking van de plaatsingsvisie, niet gekoppeld aan grootschalige infrastructuur of het betrof kleine clusters waarmee afbreuk gedaan werd aan het bovenregionale ruimtelijke concept. </li>
            <li>Er zijn geen windturbines geprojecteerd langs de A4 in regio Holland Rijnland. Deze locaties zijn vanuit landschap, cultuurhistorie en ruimtelijke kwaliteit niet als meest kansrijk beoordeeld. </li>
            <li>De windturbines van de regio Alblasserwaard langs de A15, die zich binnen de belemmeringszone voor geluid bevinden, zijn in dit alternatief vervallen. </li>
        </ul>

        <p>Om op provinciaal niveau aan de doelstellingen te voldoen zijn de elders vervallen windturbines, in totaal 7 stuks, toegevoegd binnen de regio Rotterdam-Den Haag, in aansluiting op stedelijk gebied of gekoppeld aan grootschalige infrastructuur, omdat hier binnen de zoekgebieden de meeste ruimte beschikbaar is en windturbines hier het beste aansluiten bij de provinciale plaatsingsvisie. </p>
        <ImageDownload title="Kaartbeeld alternatief landschap (windenergie)" defaultImage="energietransitie/images/20220505_Alternatief 3_wind.jpg" largeImage="energietransitie/images/20220505_Alternatief 3_wind.pdf" fileSize="1,1 MB" />
        
        <strong>Zonne-energie</strong>
        <p>Voor de zonne-energie is ten opzichte van alternatief 1 optimalisatie doorgevoerd vanuit de volgende principes:</p>
        <ul>
            <li>Zoveel mogelijk ontzien van gebieden die minder kansrijk beoordeeld zijn op basis van landschap, cultuurhistorie en ruimtelijke kwaliteit </li>
            <li>Meer clustering van zonne-energie vanuit de gedachte dat een scherpere keuze tussen behoud en ontwikkeling van landschappen verrommeling tegengaat en ruimtelijke kwaliteit ten goede komt. </li>
        </ul>
        <ImageDownload title="Kaartbeeld alternatief landschap (zonne-energie)" defaultImage="energietransitie/images/20220505_Alternatief 3_zon.jpg" largeImage="energietransitie/images/20220505_Alternatief 3_zon.pdf" fileSize="1,3 MB" />
        <p>De verdeling van windturbines en zonnevelden in dit alternatief levert een aantal opvallende inzichten:</p>
        <ul>
            <li>Door de volledige provincie te benutten voor de opgetelde doelstelling voor windenergie vanuit de energieregio’s wordt het mogelijk om beter aan te sluiten bij de bestaande locaties en, in lijn met de plaatsingsvisie, te bouwen aan een bovenregionaal ruimtelijk concept. </li>
            <li>De regio’s Drechtsteden en Rotterdam – Den Haag bieden weinig ruimte, maar ook weinig aanleiding voor een herverdeling van het areaal aan zonnevelden over de zoekgebieden vanuit landschappelijk oogpunt. </li>
            <li>In Holland Rijnland en Midden-Holland maakt meer clustering het ontzien van waardevolle landschappen mogelijk en ontstaan daarnaast kansen voor ontwikkeling van landschappen met nieuwe kwaliteiten.</li>
        </ul>

        <h4>Alternatief 4: haalbaar en betaalbaar </h4>
        <p>Dit alternatief is opgesteld om te onderzoeken hoe de invulling van de zoekgebieden er uit ziet bij optimalisatie vanuit het perspectief van het elektriciteitsnetwerk. Verschil met de andere alternatieven is dat wordt uitgegaan van een 50-50 verdeling voor de opwek van wind- en grootschalige zonne-energie. Dit betekent dat in dit alternatief meer windenergie geprojecteerd is ten opzichte van de andere alternatieven (50 in plaats van 32 turbines) en juist minder zonne-energie (1250 hectare in plaats van 1460 hectare). Bij de verdeling van de extra turbines is gekeken naar de beschikbare capaciteit in het huidige elektriciteitsnetwerk, voor zover dit bekend is. Het (kleinere) areaal aan zonnevelden is herverdeeld over de clusters van zoekgebieden, waarbij in eerste instantie gekeken is naar combinatie met nieuwe of bestaande windturbines en in tweede instantie naar de netwerkcapaciteit. Dit biedt naar verwachting voordelen voor de uitbreidingsopgave van het elektriciteitsnetwerk en de termijn waarop zonnevelden en windturbines gerealiseerd kunnen worden. </p>

        
        <ImageDownload title="Kaartbeeld alternatief haalbaar en betaalbaar (zonne- en windenergie)" defaultImage="energietransitie/images/20220505_Alternatief 4_zonwind.jpg" largeImage="energietransitie/images/20220505_Alternatief 4_zonwind.pdf" fileSize="1,5 MB" />
        
        <strong>Windenergie</strong>
        <p>Ten opzichte van alternatief RES 1.0- basis zijn in dit alternatief meer windturbines opgenomen. Deze zijn vooral geprojecteerd in regio Holland Rijnland: rond de N11, de A4 en in de Duin- en Bollenstreek. In regio Rotterdam – Den Haag zijn extra windturbines opgenomen rond de A15/ het havengebied en langs de A4 en in regio Drechtsteden staan extra windturbines langs de A16. </p>
        <ImageDownload title="Kaartbeeld alternatief haalbaar en betaalbaar (windenergie)" defaultImage="energietransitie/images/20220505_Alternatief 4_wind.jpg" largeImage="energietransitie/images/20220505_Alternatief 4_wind.pdf" fileSize="1,1 MB" />
        
        <strong>Zonne-energie</strong>
        <p>Voor zonne-energie laat dit alternatief ten opzichte van alternatief RES 1.0- basis de volgende verschuivingen zien: </p>
        <ul>
            <li>In regio Drechtsteden is fors minder oppervlak nodig, wat vooral ten goede komt aan de zone rond A15/spoorlijn, waar het zoekgebied beperkt ruimte biedt voor de regionale opgave. </li>
            <li>In regio Holland Rijnland is een kleine vermindering van het benodigd oppervlak zonneveld te zien. Het accent verschuift met een groter areaal in de N11 zone, ten oosten van Alphen aan den Rijn en ook bij het Valkenburgse Meer/ knoop A44. Aan een aantal kleinere en ten opzichte van de aansluitstations meer perifeer gelegen clusters van zoekgebieden is geen oppervlak toegekend, bijvoorbeeld de clusters in het noorden van de polder Nieuwkoop, de oeverzones van de Kagerplassen of rond de N208. </li>
            <li>Het oppervlak te realiseren zonneveld in Midden-Holland is gelijk aan alternatief RES 1.0- basis. In de Zuidplaspolder is een accentverschuiving te zien van het Middengebied naar de zone rond de A12. Het cluster rond Krimpen wordt meer benut, terwijl het cluster bij Driebruggen/Waarder juist onbenut blijft. </li>
            <li>De opgave voor zonneveld in regio Rotterdam-Den Haag is in dit alternatief circa 80 hectare kleiner dan in het basisalternatief. Het oppervlak zonneveld in het poldergebied van Voorne-Putten is fors verkleind. In een aantal clusters is het areaal juist verhoogd, zoals langs de A4 en in de omgeving van het Brielse Meer. Voor een groot aantal clusters is het oppervlak gelijk gebleven. </li>
        </ul>
        <ImageDownload title="Kaartbeeld alternatief haalbaar en betaalbaar (zonne-energie)" defaultImage="energietransitie/images/20220505_Alternatief 4_zon.jpg" largeImage="energietransitie/images/20220505_Alternatief 4_zon.pdf" fileSize="1,3 MB" />
        <p>Het kleinere areaal te realiseren zonnevelden levert in regio Drechtsteden keuzeruimte op voor verdere afweging en ontwerp binnen de krap begrensde zoekgebieden. In Holland Rijnland valt op dat een aantal clusters voor zonne-energie die bij alternatief landschap ontzien zijn, bij het alternatief ‘haalbaar en betaalbaar’ juist benut worden voor extra oppervlakte zonneveld. Hetzelfde zien we in Midden-Holland rond Krimpen en bij Reeuwijk. In Rotterdam – Den Haag biedt het verkleinde areaal zonneveld in combinatie met het netwerkperspectief de mogelijkheid om nog sterker aan te sluiten bij bestaand stedelijk gebied en grootschalige infrastructuur. Voor windenergie laat dit alternatief ten opzichte van de andere alternatieven vooral in regio Holland Rijnland een sterk afwijkend beeld zien. </p>

        <h3>Beoordeling alternatieven</h3>
        <p>De beoordeling heeft plaatsgevonden in twee rondes. In de eerste ronde is alternatief 1 RES 1.0- basis beoordeeld ten opzichte van de referentiesituatie (huidige situatie inclusief plannen voor wind- en zonne-energie die in ontwikkeling zijn). In de tweede ronde is beoordeeld in hoeverre de andere alternatieven beter of minder goed beoordeeld worden ten opzichte van alternatief RES 1.0- basis. De opgestelde beoordeling, zowel bij de eerste als bij de tweede ronde, is direct gebaseerd op de beoordeling van de individuele zoekgebieden voor zon en wind (zie hoofdstuk 4 voor de beoordeling per criterium en paragraaf 4.11 voor de samenvatting van alle beoordelingscriteria). In paragraaf 5.7 is een toelichting van de scores van de beoordeling per ronde opgenomen.  </p>

        <p>De effecten zijn beoordeeld aan de hand van een 5-puntsschaal:</p>
        <ul>
            <li>Positief effect ++</li>
            <li>Beperkt positief effect + </li>
            <li>Neutraal effect 0 </li>
            <li>Beperkt negatief effect -  </li>
            <li>Negatief effect – </li>
        </ul>
        
        <strong>Beoordeling ronde 1: Alternatief RES 1.0- basis ten opzichte van de referentiesituatie </strong>
        <table className="w100" id="paragraaf-5-7-1">
        <thead>
          <tr>
            <th>Beoordelingscriterium</th>
            <th>
              Alternatief
              <br />
              RES 1.0- basis
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="kopje ">
            <td colspan="2">Energieproductie</td>
          </tr>
          <tr>
            <td>Opwek wind (TWh/jr)</td>
            <td>0,6</td>
          </tr>
          <tr>
            <td>Aantal windturbines (5,6MW)</td>
            <td>32</td>
          </tr>
          <tr>
            <td>Opwek zon (TWh/jr)</td>
            <td>1,0</td>
          </tr>
          <tr>
            <td>Aantal ha zonnepark</td>
            <td>1460</td>
          </tr>
          <tr>
            <td>Opwek wind + zon (TWh/jr)</td>
            <td>++ (1,6 TWh/jr) </td>
          </tr>
          <tr>
            <td>
              Vermeden CO2-uitstoot op basis te verwachten energieopbrengst in
              TWh
            </td>
            <td>++</td>
          </tr>
          <tr className="kopje wind">
            <td colspan="2">Wind Leefomgeving</td>
          </tr>
          <tr>
            <td>Geluid</td>
            <td>-</td>
          </tr>
          <tr>
            <td>Externe veiligheid</td>
            <td>-</td>
          </tr>
          <tr>
            <td>Woningbouwlocaties</td>
            <td>0</td>
          </tr>
          <tr className="kopje wind">
            <td colspan="2">Wind Natuur</td>
          </tr>
          <tr>
            <td>Natura-2000 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>NNN </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Weidevogelgebieden </td>
            <td>- </td>
          </tr>
          <tr>
            <td>Ganzenrustgebieden </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Stiltegebieden </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Vogels en niet-broedvogels </td>
            <td>-- </td>
          </tr>
          <tr>
            <td>Vogeltrek </td>
            <td>-- </td>
          </tr>
          <tr>
            <td>Vleermuizen </td>
            <td>-- </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="2">Wind Netaansluiting </td>
          </tr>
          <tr>
            <td>Inpassing energie-infrastructuur </td>
            <td>0 </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="2">Wind water </td>
          </tr>
          <tr>
            <td>Drinkwatergebieden </td>
            <td>0 </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="2">Wind Landschap </td>
          </tr>
          <tr>
            <td>Ruimte </td>
            <td>- </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="2">Zon Leefomgeving </td>
          </tr>
          <tr>
            <td>Woningbouwlocaties </td>
            <td>0 </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="2">Zon Natuur </td>
          </tr>
          <tr>
            <td>Natura-2000 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>NNN </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Weidevogelgebieden </td>
            <td>- </td>
          </tr>
          <tr>
            <td>Ganzenrustgebieden </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Stiltegebieden </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Vleermuizen </td>
            <td>- </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="2">Zon Netaansluiting </td>
          </tr>
          <tr>
            <td>Inpassing energie-infrastructuur </td>
            <td>0 </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="2">Zon Water </td>
          </tr>
          <tr>
            <td>Drinkwatergebieden </td>
            <td>0 </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="2">Zon Landschap </td>
          </tr>
          <tr>
            <td>Ruimte </td>
            <td>- </td>
          </tr>
        </tbody>
      </table>

      <strong>Beoordeling ronde 2: Overige alternatieven ten opzichte van alternatief RES 1.0- basis</strong>
      <table className="w100" id="paragraaf-5-7-2">
        <thead>
          <tr>
            <th>Beoordelingscriterium </th>
            <th colspan="3">Alternatieven</th>
          </tr>
          <tr>
            <th>&nbsp;</th>
            <th>RES 1.0 na besluitvorming </th>
            <th>Landschap </th>
            <th>Haalbaar en betaalbaar (netcapaciteit) </th>
          </tr>
        </thead>
        <tbody>
          <tr className="kopje">
            <td colspan="4">Energieproductie </td>
          </tr>
          <tr>
            <td>Opwek wind (TWh/jr) </td>
            <td>0,6 </td>
            <td>0,6 </td>
            <td>0,8 </td>
          </tr>
          <tr>
            <td>Aantal windturbines (5,6MW) </td>
            <td>32 </td>
            <td>32 </td>
            <td>50 </td>
          </tr>
          <tr>
            <td>Opwek zon (TWh/jr) </td>
            <td>1,0 </td>
            <td>1,0 </td>
            <td>0,8 </td>
          </tr>
          <tr>
            <td>Aantal ha zonnepark </td>
            <td>1500 </td>
            <td>1500 </td>
            <td>1250 </td>
          </tr>
          <tr>
            <td>Opwek wind + zon (TWh/jr) </td>
            <td>0 (1,6 TWh/jr) </td>
            <td>0 (1,6 TWh/jr) </td>
            <td>0 (1,6 TWh/jr) </td>
          </tr>
          <tr>
            <td>
              Vermeden CO2-uitstoot op basis te verwachten energieopbrengst in TWh
            </td>
            <td>0 (neutraal) </td>
            <td>0 (neutraal) </td>
            <td>0 (neutraal) </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="4">Wind Leefomgeving </td>
          </tr>
          <tr>
            <td>Geluid </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Externe veiligheid </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Woningbouwlocaties </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="4">Wind Natuur </td>
          </tr>
          <tr>
            <td>Natura-2000 </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>NNN </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Weidevogelgebieden </td>
            <td>+ </td>
            <td>+ </td>
            <td>-- </td>
          </tr>
          <tr>
            <td>Ganzenrustgebieden </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Stiltegebieden </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Vogels en niet-broedvogels </td>
            <td>0 </td>
            <td>- </td>
            <td>-- </td>
          </tr>
          <tr>
            <td>Vogeltrek </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Vleermuizen </td>
            <td>0 </td>
            <td>0 </td>
            <td>- </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="4">Wind Netaansluiting </td>
          </tr>
          <tr>
            <td>Inpassing energie-infrastructuur </td>
            <td>0 </td>
            <td>- </td>
            <td>+ </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="4">Wind water </td>
          </tr>
          <tr>
            <td>Drinkwatergebieden </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr className="kopje wind">
            <td colspan="4">Wind Landschap </td>
          </tr>
          <tr>
            <td>Ruimte </td>
            <td>+ </td>
            <td>++ </td>
            <td>-- </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="4">Zon Leefomgeving </td>
          </tr>
          <tr>
            <td>Woningbouwlocaties </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="4">Zon Natuur </td>
          </tr>
          <tr>
            <td>Natura-2000 </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>NNN </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Weidevogelgebieden </td>
            <td>0 </td>
            <td>+ </td>
            <td>- </td>
          </tr>
          <tr>
            <td>Ganzenrustgebieden </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Stiltegebieden </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr>
            <td>Vleermuizen </td>
            <td>0 </td>
            <td>+ </td>
            <td>- </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="4">Zon Netaansluiting </td>
          </tr>
          <tr>
            <td>Inpassing energie-infrastructuur </td>
            <td>0 </td>
            <td>0 </td>
            <td>+ </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="4">Zon Water </td>
          </tr>
          <tr>
            <td>Drinkwatergebieden </td>
            <td>0 </td>
            <td>0 </td>
            <td>0 </td>
          </tr>
          <tr className="kopje zon">
            <td colspan="4">Zon Landschap </td>
          </tr>
          <tr>
            <td>Ruimte </td>
            <td>0 </td>
            <td>++ </td>
            <td>+ </td>
          </tr>
        </tbody>
      </table>

      <h3>Inzichten beoordeling alternatieven</h3>

      <p>De opbouw van de alternatieven leidt tot de volgende inzichten:</p>
        <ul>
        <li>De opgetelde doelstellingen van de RES’en zijn op provinciale schaal een opgave van formaat. De ontwikkelingen binnen de zoekgebieden hebben niet alleen lokale impact maar met elkaar grote impact op de kwaliteit en beleving van de provinciale ruimte in samenhang:
            <ul>
                <li>Voor windenergie is van belang in hoeverre een bovenregionaal ruimtelijk concept tot ontwikkeling kan komen. </li>
                <li>Voor zonne-energie is van belang in hoeverre het mogelijk is om te werken aan het contrast tussen ‘luwe gebieden’ en gebieden waarin zonne-energie een plek krijgt. </li>
            </ul>
        </li>
        <li>De begrenzing van de zoekgebieden is in de regio’s erg verschillend aangepakt. Waar de ene regio globaal begrensde gebieden kent met veel ruimte voor afweging en ontwerp in de volgende fase, zijn in ander regio’s gebieden op kavelniveau begrensd. </li>
        <li>Het werken in RES’en met eigen doelstellingen, oplossingen en zoekgebieden beperkt de mogelijkheid om (boven)regionale ruimtelijke samenhang te realiseren. Het kijken over de grenzen geeft hiervoor meer ruimte en brengt andere oplossingen, wellicht ook buiten de zoekgebieden, in beeld. </li>
        <li>Het verdelen van hectares en aantallen over de zoekgebieden biedt geen inzicht in de werkelijke kwaliteit die met de projecten gerealiseerd kan worden. Koppeling van energie-opwekking aan andere opgaven in integrale gebiedsontwikkeling is in dit MER niet in beeld gebracht, maar zou bij de verdere afweging en uitwerking zeker een rol moeten spelen. </li>
        </ul>

        <p>De beoordeling van de alternatieven laat onder andere zien dat: </p>
        <ul>
        <li>Bij windenergie is er bij het alternatief RES 1.0- basis een negatief effect gescoord op natuur en met name voor weidevogels, vogels en niet-broedvogels en vleermuizen. Alleen voor weidevogels komt alternatief landschap ten opzichte van alternatief RES 1.0- basis beter uit de bus. Voor de andere criteria is er geen verbetering of zelfs een verslechtering bij de alternatieven 2, 3 en 4. </li>
        <li>Ook bij zonne-energie is er bij alternatief RES 1.0- basis een – toegekend ten aanzien van weidevogelgebieden en vleermuizen. Bij deze criteria scoort alternatief landschap wel beter, en alternatief haalbaar en betaalbaar juist slechter. </li>
        <li>Alternatief RES 1.0- basis laat een negatief effect zien voor criterium ‘ruimte’ zowel bij wind- als bij zonne-energie. Alternatief landschap betekent zowel voor zon als wind een verbetering, terwijl ook het alternatief haalbaar en betaalbaar als gevolg van het clusteren van zonne-energie beter scoort op criterium ‘ruimte’. </li>
        <li>Naar verwachting scoort alternatief ‘haalbaar en betaalbaar’ inderdaad het best op criterium ‘inpassing energie-infrastructuur’. Het ophogen van het aantal windturbines binnen de zoeklocaties maakt realisatie van een bovenregionaal ruimtelijk windenergieconcept echter lastig zo niet onmogelijk. Bovendien leert de ervaring dat van alle locaties die in beeld komen in de loop van de tijd altijd een substantieel aantal afvalt. Het is daarom de vraag hoe kansrijk realisatie van dit alternatief is. </li>
        </ul>
        <p>Bij nadere uitwerking van de plannen moet blijken of de negatieve effecten vermeden of gemitigeerd kunnen worden. Bovendien moet nog blijken welke nieuwe kwaliteiten kunnen ontstaan door locatiekeuze, ontwerp en inrichting in samenhang met andere opgaven. Indien beide kanten van de opgave op overtuigende wijze worden aangetoond, lijkt het mogelijk om de opgetelde doelstellingen voor energie-opwekking vanuit de RES’en binnen Zuid-Holland in te kunnen vullen. Het is geen gegeven dat dit doel tijdig wordt behaald. Veel factoren kunnen beïnvloeden hoeveel zonne- en windenergie uiteindelijk gerealiseerd kan worden. Zoals beperkingen in de ruimte en de mate waarin een locatie en de keuze voor zonne- en windenergie maatschappelijk geaccepteerd wordt. Verschuiving van opgaven tussen de regio’s is vanuit bovenregionale samenhang gewenst, maar lastig te verenigen met de huidige werkwijze in de RES’en. </p>

        <h3>Vervolgprocedure </h3>
        <p>Volgens de bepalingen in de Wet milieubeheer zal dit MER worden voorgelegd aan de Commissie m.e.r. In een toetsingsadvies geeft de Commissie aan of het milieueffectrapport voldoende informatie bevat om het plan (de Herziening Omgevingsbeleid module Energietransitie, specifiek de Maatregel in het omgevingsprogramma RES-zoekgebieden zon en wind) te kunnen vaststellen.</p>
        <p>Het ontwerp van de Herziening Omgevingsbeleid module Energietransitie wordt ter inzage gelegd. Parallel aan de inzageperiode wordt dit MER aan de Commissie m.e.r. voorgelegd voor een toetsingsadvies. In de Integrale Commissie Provinciale Staten van 1 juni heeft het ontwerp ter kennisneming en bespreking voorgelegen. Na bespreking in PS start de inzageperiode. De zienswijzen en bedenkingen worden betrokken bij een mogelijke aanvulling van het MER die in dat geval opnieuw door GS vastgesteld moet worden. In het vierde kwartaal van 2022 vindt vervolgens de besluitvorming over de herziening van de module Energietransitie plaats door PS.</p>
        <p>In het ontwerpbeleid (Omgevingsprogramma) zijn geen nadere keuzes gemaakt in de begrenzing van de zoekgebieden, dit zal in het RES 2.0 proces gebeuren. De aandachtspunten per zoekgebied kunnen benut worden bij de concretisering van de zoekgebieden tot specifieke locaties en projecten in het RES 2.0-proces. De RES’en 2.0 dienen voor 1 juli 2023 vastgesteld te zijn door de samenwerkende gemeenten, waterschappen en de provincie.  </p>

    </>
  ),
  sources_used: [1, 2],
  prev: "",
  next: "/energietransitie/1",
};

export default data;
